var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8708 5.84107C13.8708 3.95983 12.9166 2.98438 11.0602 2.98438H2.81928C0.962892 2.98438 0 3.95983 0 5.84107V17.651C0 19.5236 0.962892 20.5077 2.81928 20.5077H4.12048V22.1277C4.12048 24.0089 5.09205 24.9844 6.93976 24.9844H15.1807C17.0284 24.9844 18 24.0089 18 22.1277V10.2393C18 8.35809 17.0371 7.38263 15.1807 7.38263H13.8708V5.84107ZM2.95807 18.8007C2.11663 18.8007 1.70024 18.3478 1.70024 17.5465V5.94558C1.70024 5.1356 2.11663 4.69142 2.95807 4.69142H10.9128C11.7542 4.69142 12.1706 5.1356 12.1706 5.94558V7.38263H6.93976C5.08337 7.38263 4.12048 8.35809 4.12048 10.2393V18.8007H2.95807ZM16.2998 10.3438V22.0232C16.2998 22.8244 15.8747 23.2773 15.0333 23.2773H7.08723C6.24578 23.2773 5.82072 22.8244 5.82072 22.0232V10.3438C5.82072 9.53386 6.24578 9.08968 7.08723 9.08968H15.0333C15.8747 9.08968 16.2998 9.53386 16.2998 10.3438Z",
    fill: "#1C1C1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllActivity);
export default __webpack_public_path__ + "static/media/allActivity.f67862873961677d4def9dd07d39c736.svg";
export { ForwardRef as ReactComponent };